import React from "react";
import { all_routes } from "../../../../Router/all_routes";
import RefreshIcon from "../../../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../../../core/common/tooltip-content/collapes";
import { Link } from "react-router-dom";
import { ArrowLeft, Calendar } from "feather-icons-react/build/IconComponents";
import { DatePicker } from "antd";

const ViewJob = () => {
  const route = all_routes;

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/applicantTracking/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    View Opening
                  </h4>
                </ol>
              </nav>
            </div>
          </div>
          <ul className="table-top-head">
            <RefreshIcon />
            <CollapesIcon />
            <li>
              <div className="page-btn">
                <Link
                  to={route.applicanttrackingjobsPosting}
                  className="btn btn-secondary"
                >
                  <ArrowLeft className="me-2" />
                  Back to Jobs
                </Link>
              </div>
            </li>
          </ul>
        </div>
        <div className="card table-list-card">
          <div className="card-body p-4">
            <form className="add-product-form ">
              <div className="add-product">
                <div className="row">
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Company<span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Froiden Technologies Pvt Ltd"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Job Title<span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Manager- Revenue & Analytics"
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="summer-description-box">
                      <label className="form-label">Job Description</label>
                      <textarea
                        rows="6"
                        className="form-control list"
                        value="We are seeking an enthusiastic and results-driven Sales Representative to join our dynamic team. As a Sales Representative, you will be responsible for driving sales, building relationships with new and existing clients, and promoting our products/services. You will work closely with the sales team to meet and exceed sales targets and contribute to the overall success of the company."
                        disabled
                      />
                      <p className="fs-14 mt-1">Maximum 60 Words</p>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="summer-description-box">
                      <label className="form-label">Job Requirement</label>
                      <textarea
                        rows="8"
                        className="form-control list"
                        value="Identify and target potential clients through lead generation and research.
Engage with potential customers to understand their needs and offer suitable products/services.
Develop and maintain relationships with existing clients, ensuring customer satisfaction and repeat business.
Conduct sales presentations, product demonstrations, and meetings with prospective clients.
Negotiate contracts, close sales, and ensure the timely processing of orders.
Maintain accurate records of client interactions, sales, and transactions in CRM systems.
Achieve individual and team sales targets within set deadlines.
Stay updated on industry trends, products, and competitor activities to effectively sell the company’s offerings."
                        disabled
                      />
                      <p className="fs-14 mt-1">Maximum 60 Words</p>
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Job Locations<span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Hyderabad"
                      />{" "}
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Job Category
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Sales"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Skills<span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Speaking skills"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Total Positions
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="10"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Start Date
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        End Date<span className="text-danger ms-1">*</span>
                      </label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="form-control datetimepicker"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Status
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Active"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Job Type
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Full Time"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Work Experience
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="1 Year"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Show Pay By
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Maximum Salary"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Starting salary
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="10 LPA"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Maximum salary
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="12 LPA"
                      />{" "}
                    </div>
                  </div>
                  <div className="col-sm-6 col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Rate
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Hour"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Meta Title
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control list"
                        disabled
                        value="Manager- Revenue & Analytics"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Meta Description
                        <span className="text-danger ms-1">*</span>
                      </label>
                      <textarea
                        className="form-control list"
                        rows="4"
                        disabled
                        value="Join our dynamic team as a Sales Representative! Drive sales, build relationships, and help promote our products/services. Competitive salary, benefits, and growth opportunities. Apply today!"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label">
                      Ask applicants for
                      <span className="text-danger ms-1">*</span>
                    </label>
                    <div className="p-3 bg-light rounded d-flex align-items-center border mb-3">
                      <div className=" d-flex align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="warranties"
                            defaultValue="option1"
                            disabled
                          />
                          <label
                            className="form-check-label"
                            htmlFor="warranties"
                          >
                            Gender
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="manufacturer"
                            defaultValue="option2"
                            disabled
                          />
                          <label
                            className="form-check-label"
                            htmlFor="manufacturer"
                          >
                            Date of Birth(Required)
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="expiry"
                            defaultValue="option2"
                            disabled
                          />
                          <label className="form-check-label" htmlFor="expiry">
                            Country
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="expiry"
                            defaultValue="option2"
                            disabled
                          />
                          <label className="form-check-label" htmlFor="expiry">
                            Address
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <label className="form-label">
                      Section Visibility
                      <span className="text-danger ms-1">*</span>
                    </label>
                    <div className="p-3 bg-light rounded d-flex align-items-center border mb-3">
                      <div className=" d-flex align-items-center">
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="warranties"
                            defaultValue="option1"
                            disabled
                          />
                          <label
                            className="form-check-label"
                            htmlFor="warranties"
                          >
                            Profile Image
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="manufacturer"
                            defaultValue="option2"
                            disabled
                          />
                          <label
                            className="form-check-label"
                            htmlFor="manufacturer"
                          >
                            Resume
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="expiry"
                            defaultValue="option2"
                            disabled
                          />
                          <label className="form-check-label" htmlFor="expiry">
                            Cover letter
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="expiry"
                            defaultValue="option2"
                            disabled
                          />
                          <label className="form-check-label" htmlFor="expiry">
                            Terms & Conditions
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewJob;
